import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/duyurular/page.tsx");
